<div [ngClass]="{ 'button-double-line-arrow': true, 'button-double-line-arrow-border': withBorder, 'is_disabled': isDisabled }">
    <div *ngIf="icon !== ''" class="dbla_icon" [inlineSVG]="icon"></div>
    <div class="dbla_text {{icon === '' ? '' : 'dbla_text_icon'}}">
        <div class="{{firstLineIsBold ? 'bdl_bold' : ''}}">{{firstLine}}</div>
        <div *ngIf="secondLine !== ''">{{secondLine}}</div>
    </div>
    <div class="dbla_arrow"><div *ngIf='showArrow' [inlineSVG]="'assets/images/forward.svg'"></div></div>
</div>